import { Radio, RadioGroup } from '@fluentui/react-components';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PermissionScope } from '../../../../../../../api/types.gen';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsHStack } from '../../PermissionsHStack';
import { PermissionsField } from '../PermissionsField';

export function PermissionsEditGroup() {
  const { t } = useTranslation();
  const { control } = useFormContext<IPermissionsDialogForm>();
  return (
    <PermissionsField label={t('permissions.modifyAction.editGroup.label')}>
      <Controller
        control={control}
        name="editItems"
        render={({ field: { value, onChange } }) => (
          <RadioGroup>
            <PermissionsHStack>
              <Radio
                label={t('permissions.modifyAction.editGroup.options.none')}
                checked={value === PermissionScope.NONE}
                value={PermissionScope.NONE}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
              <Radio
                label={t('permissions.modifyAction.editGroup.options.own')}
                checked={value === PermissionScope.OWNED}
                value={PermissionScope.OWNED}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
              <Radio
                label={t('permissions.modifyAction.editGroup.options.all')}
                checked={value === PermissionScope.ALL}
                value={PermissionScope.ALL}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
            </PermissionsHStack>
          </RadioGroup>
        )}
      />
    </PermissionsField>
  );
}
